import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Trans } from "react-i18next";
import { Collapse, Dropdown } from "react-bootstrap";

import { APP_VERSION } from "../../Util/constant";
import ThemeToggelSwitch from "./ThemeToggelSwitch";
import CurrentTime from "./CurrentTime";
import { ProfileContext } from "../context/ProfileContext";
class Sidebar extends Component {
    state = {
        currentTime: new Date().toLocaleString(),
    };

    static contextType = ProfileContext;

    toggleMenuState(menuState) {
        if (this.state[menuState]) {
            this.setState({ [menuState]: false });
        } else if (Object.keys(this.state).length === 0) {
            this.setState({ [menuState]: true });
        } else {
            Object.keys(this.state).forEach((i) => {
                this.setState({ [i]: false });
            });
            this.setState({ [menuState]: true });
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        document.querySelector("#sidebar").classList.remove("active");
        Object.keys(this.state).forEach((i) => {
            this.setState({ [i]: false });
        });
        const dropdownPaths = [
            { path: "/deposit&transaction", state: "depositMenuOpen" },
            { path: "/profile", state: "profileMenuOpen" },
            { path: "/support", state: "helpMenuOpen" },
        ];

        dropdownPaths.forEach((obj) => {
            if (this.isPathActive(obj.path)) {
                this.setState({ [obj.state]: true });
            }
        });
    }

    render() {
        const { profileData } = this.context;
        return (
            <nav
                className="sidebar sidebar-offcanvas fixed-sidebar overflow-scroll"
                id="sidebar"
                style={{ display: "flex", flexDirection: "column", height: "100vh", overflowY: "auto", justifyContent: "space-between", }}   >
                <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
                    <a className="sidebar-brand brand-logo" href="index.html">
                        <img src={require("../../assets/images/portal_long.png")} alt="logo" />
                    </a>

                    <a className="sidebar-brand brand-logo-mini" href="index.html">
                        <img src={require("../../assets/images/portal_mini.png")} alt="logo" />{" "}
                    </a>
                </div>

                <ul className="nav">
                    <li>
                        <p style={{ textAlign: "center", marginBottom: "0px", }}   >
                            <CurrentTime />
                        </p>
                    </li>
                    <li className={this.isPathActive("/dashboard") ? "nav-item menu-items active" : "nav-item menu-items"}   >
                        <Link className="nav-link hover-change-color" to="/dashboard">
                            <span className="menu-icon">
                                <i className="mdi mdi-view-grid-outline" style={{ fontSize: "24px" }}  ></i>
                            </span>
                            <span className="menu-title">
                                <Trans>Dashboard</Trans>
                            </span>
                        </Link>
                    </li>
                    <li className={this.isPathActive("/wallet") ? "nav-item menu-items active" : "nav-item menu-items hover-change-color"}  >
                        <Link className="nav-link hover-change-color" to="/wallet">
                            <span className="menu-icon">
                                <i className="mdi mdi-wallet-outline" style={{ fontSize: "24px" }}  ></i>
                            </span>
                            <span className="menu-title">
                                <Trans>Wallet</Trans>
                            </span>
                        </Link>
                    </li>
                    {/* AVFX Wallet  when AVFX enabled than shows only  */}
                    {profileData?.avfx_enable && (
                        <li className={this.isPathActive("/avfxwallet") ? "nav-item menu-items active" : "nav-item menu-items"} >
                            <Link className="nav-link hover-change-color" to="/avfxwallet">
                                <span className="menu-icon">
                                    <i className="mdi mdi-cash-multiple" style={{ fontSize: "24px" }}></i>
                                </span>
                                <span className="menu-title">
                                    <Trans>AVFX Wallet</Trans>
                                </span>
                            </Link>
                        </li>
                    )}
                    <li className={this.isPathActive("/deposit&transaction") ? "nav-item menu-items active" : "nav-item menu-items hover-change-color"}   >
                        <div className={this.state.depositMenuOpen ? "nav-link menu-expanded" : "nav-link"} onClick={() => this.toggleMenuState("depositMenuOpen")} data-toggle="collapse"   >
                            <span className="menu-icon">
                                <i className="mdi mdi-coin-outline" style={{ fontSize: "24px" }} ></i>
                            </span>
                            <span className="menu-title">Deposit & Transaction</span>
                            <i className={`mdi mdi-${this.state.depositMenuOpen ? "chevron-up" : "chevron-down"}`} style={{ fontSize: "20px" }}  ></i>
                        </div>
                        <Collapse in={this.state.depositMenuOpen}>
                            <ul className="nav flex-column sub-menu">
                                <li className="nav-item">
                                    <Link className={this.isPathActive("/deposit&transaction/deposittowallet") ? "nav-link active" : "nav-link hover-change-color"} to="/deposit&transaction/deposittowallet" >
                                        Deposit To Wallet
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={this.isPathActive("/deposit&transaction/fundtransfer") ? "nav-link active " : "nav-link hover-change-color"} to="/deposit&transaction/fundtransfer"  >
                                        Fund Transfer
                                    </Link>
                                </li>
                            </ul>
                        </Collapse>
                    </li>
                    <li className={this.isPathActive("/onlinestore") ? "nav-item menu-items active" : "nav-item menu-items"} >
                        <Link className="nav-link hover-change-color" to="/onlinestore">
                            <span className="menu-icon">
                                <i className="mdi mdi-storefront" style={{ fontSize: "24px" }}  ></i>
                            </span>
                            <span className="menu-title">
                                <Trans>Online Store</Trans>
                            </span>
                        </Link>
                    </li>

                    <li
                        className={this.isPathActive("/networkreward") ? "nav-item menu-items active" : "nav-item menu-items"}>
                        <Link className="nav-link hover-change-color" to="/networkreward">
                            <span className="menu-icon">
                                <i className="mdi mdi-trophy-outline" style={{ fontSize: "24px" }} ></i>
                            </span>
                            <span className="menu-title">
                                <Trans>Network Reward</Trans>
                            </span>
                        </Link>
                    </li>
                    <li className={this.isPathActive("/myteam") ? "nav-item menu-items active" : "nav-item menu-items"}   >
                        <Link className="nav-link hover-change-color" to="/myteam">
                            <span className="menu-icon">
                                <i className="mdi mdi-account-group" style={{ fontSize: "24px" }}  ></i>
                            </span>
                            <span className="menu-title">
                                <Trans>My Team</Trans>
                            </span>
                        </Link>
                    </li>
                    <li className={this.isPathActive("/withdrawal") ? "nav-item menu-items active" : "nav-item menu-items"}  >
                        <Link className="nav-link hover-change-color" to="/withdrawal">
                            <span className="menu-icon">
                                <i className="mdi mdi-credit-card-plus-outline" style={{ fontSize: "24px" }}  ></i>
                            </span>
                            <span className="menu-title">
                                <Trans>Withdrawal</Trans>
                            </span>
                        </Link>
                    </li>
                    <li className={this.isPathActive("/rankrecognition") ? "nav-item menu-items active" : "nav-item menu-items"}  >
                        <Link className="nav-link hover-change-color" to="/rankrecognition">
                            <span className="menu-icon">
                                <i className="mdi mdi-bookmark-outline" style={{ fontSize: "24px" }}   ></i>
                            </span>
                            <span className="menu-title">
                                <Trans>Rank & Recognition</Trans>
                            </span>
                        </Link>
                    </li>

                    {/* Profile */}
                    <li className={this.isPathActive("/profile") ? "nav-item menu-items active" : "nav-item menu-items"}>
                        <div className={this.state.profileMenuOpen ? "nav-link menu-expanded" : "nav-link"}
                            onClick={() => this.toggleMenuState("profileMenuOpen")}
                            data-toggle="collapse">
                            <span className="menu-icon">
                                <i className="mdi mdi-account-circle-outline" style={{ fontSize: "24px" }}  ></i>
                            </span>
                            <span className="menu-title hover-change-color">Profile</span>
                            <i className={`mdi mdi-${this.state.profileMenuOpen ? "chevron-up" : "chevron-down"}`} style={{ fontSize: "20px" }}   ></i>
                        </div>
                        <Collapse in={this.state.profileMenuOpen}>
                            <div>
                                <ul className="nav flex-column sub-menu">
                                    <li className="nav-item">
                                        {" "}
                                        <Link
                                            className={
                                                this.isPathActive("/profile/accountsettings")
                                                    ? "nav-link active r"
                                                    : "nav-link hover-change-color"
                                            }
                                            to={{
                                                pathname: "/profile/accountsettings",
                                                state: { selectedTab: "Account Setting" },
                                            }}
                                        >
                                            Account Setting
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        {" "}
                                        <Link
                                            className={
                                                this.isPathActive("/profile/accountsettings")
                                                    ? "nav-link active "
                                                    : "nav-link hover-change-color"
                                            }
                                            to={{
                                                pathname: "/profile/accountsettings",
                                                state: { selectedTab: "Security" },
                                            }}
                                        >
                                            Security
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        {" "}
                                        <Link
                                            className={
                                                this.isPathActive("/profile/accountsettings")
                                                    ? "nav-link active "
                                                    : "nav-link hover-change-color"
                                            }
                                            to={{
                                                pathname: "/profile/accountsettings",
                                                state: { selectedTab: "User KYC" },
                                            }}
                                        >
                                            User KYC
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        {" "}
                                        <Link
                                            className={
                                                this.isPathActive("/profile/accountsettings")
                                                    ? "nav-link active "
                                                    : "nav-link hover-change-color"
                                            }
                                            to={{
                                                pathname: "/profile/accountsettings",
                                                state: { selectedTab: "Withdrawal Setting" },
                                            }}
                                        >
                                            Withdrawal Setting
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        {" "}
                                        <Link
                                            className={
                                                this.isPathActive("/profile/activitylog")
                                                    ? "nav-link active"
                                                    : "nav-link hover-change-color"
                                            }
                                            to={{
                                                pathname: "/profile/activitylog",
                                            }}
                                        >
                                            Activity Logs
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </Collapse>
                    </li>
                    {/* Help */}
                    <li
                        className={
                            this.isPathActive("/support")
                                ? "nav-item menu-items active"
                                : "nav-item menu-items"
                        }
                    >
                        <div
                            className={
                                this.state.helpMenuOpen ? "nav-link menu-expanded" : "nav-link"
                            }
                            onClick={() => this.toggleMenuState("helpMenuOpen")}
                            data-toggle="collapse"
                        >
                            <span className="menu-icon">
                                <i
                                    className="mdi mdi-help-circle-outline"
                                    style={{ fontSize: "24px" }}
                                ></i>
                            </span>
                            <span className="menu-title">Help</span>
                            <i
                                className={`mdi mdi-${this.state.helpMenuOpen ? "chevron-up" : "chevron-down"
                                    }`}
                                style={{ fontSize: "20px" }}
                            ></i>
                        </div>
                        <Collapse in={this.state.helpMenuOpen}>
                            <div>
                                <ul className="nav flex-column sub-menu">
                                    <li className="nav-item">
                                        {" "}
                                        <Link
                                            className={
                                                this.isPathActive("/support")
                                                    ? "nav-link active"
                                                    : "nav-link hover-change-color"
                                            }
                                            to={{
                                                pathname: "/support",
                                            }}
                                        >
                                            Support Ticket
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        {" "}
                                        <a
                                            className="nav-link hover-change-color"
                                            href="https://faq-arbitfx.com/"
                                            target="_blank" // Opens link in a new tab
                                            rel="noopener noreferrer" // Improves security by preventing access to the window.opener property
                                        >
                                            FAQ
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        {" "}
                                        <a
                                            className="nav-link hover-change-color"
                                            href="https://arbitfx-help.freshdesk.com/support/solutions"
                                            target="_blank" // Opens link in a new tab
                                            rel="noopener noreferrer" // Improves security by preventing access to the window.opener property
                                        >
                                            User Guide
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        {" "}
                                        <Link
                                            className={
                                                this.isPathActive("/document")
                                                    ? "nav-link active"
                                                    : "nav-link hover-change-color"
                                            }
                                            to={{
                                                pathname: "/document",
                                            }}
                                        >
                                            Document
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </Collapse>
                    </li>
                </ul>
                <div className="sidebar-bottom-section">
                    {/* <p
            style={{
              textAlign: "center",
              marginBottom: "0px",
              borderTop: ".5px solid",
            }}
            className="text-muted"
          >
            <CurrentTime />
          </p> */}
                    <p
                        className="text-muted"
                        style={{ textAlign: "center", marginTop: "10px" }}
                    >
                        {APP_VERSION}
                    </p>
                </div>
            </nav>
        );
    }

    isPathActive(path) {
        // Check if the current path is exactly the main path or starts with the nested path
        return (
            this.props.location.pathname === path ||
            this.props.location.pathname.startsWith(`${path}/`)
        );
    }

    componentDidMount() {
        this.onRouteChanged();
        // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
        const body = document.querySelector("body");
        document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
            el.addEventListener("mouseover", function () {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.add("hover-open");
                }
            });
            el.addEventListener("mouseout", function () {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.remove("hover-open");
                }
            });
        });
    }
}

export default withRouter(Sidebar);
